<template>
  <w-modal
    v-model="show"
    close-button="Anuluj"
    submit-button="Odbierz"
    :title="title"
    :close-on-submit="false"
    :hide-on-overlay="false"
    :hide-on-esc="false"
    @submit="receive"
    @close="close"
  >
    <div class="row">
      <div class="col-12 mb-5">
        <p>Jeżeli chcesz odebrać paczkę, wprowadź jej UID z systemu MDOK.</p>

        <w-input :model="$schema.packMdokId" @input="loadDocumentName($schema.packMdokId.$model)" />
      </div>

      <div v-if="documentName && $schema.packMdokId.$model" class="form-group col-md-12">
        <p>
          Wybrano dokument: <b>{{ documentName }}</b>
        </p>
      </div>
    </div>
  </w-modal>
</template>

<script>
import { formMixin } from '@/mixins/form';
import { mdokDocumentMixin } from '@/mixins/mdokDocument';
import { modalMixin } from '@/mixins/modal';
import schema from '@/schemas/packReceive.schema';

// @vuese
// Modal potwierdzania odbioru paczki
// @group DocumentPack
export default {
  mixins: [formMixin, mdokDocumentMixin, modalMixin],
  schema,
  props: {
    packTitle: { type: String, required: false }
  },
  data() {
    return { model: {} };
  },
  computed: {
    title() {
      return `Czy na pewno chcesz odebrać paczkę wniosków "${this.packTitle}"?`;
    }
  },
  methods: {
    // @vuese
    // Zatwierdza odbiór paczki
    receive() {
      this.$emit('receive', this.$schema.packMdokId.$model);
    }
  }
};
</script>
